/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Client,
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
    MonitoredObject,
    MonitoredObjectFromJSON,
    MonitoredObjectFromJSONTyped,
    MonitoredObjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMonitoringDeviceNested
 */
export interface ReadOnlyMonitoringDeviceNested {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    clientId: number;
    /**
     * 
     * @type {Client}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    client?: Client;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    permissions?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    readonly modules?: Array<string>;
    /**
     * 
     * @type {MonitoredObject}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    monitoredObject?: MonitoredObject;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    readonly deleted?: number;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    metadata?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    externalVehicleId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    isEva?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    monitoringDeviceType: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    monitoringDeviceStatus?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceNested
     */
    externalSystem?: number | null;
}

export function ReadOnlyMonitoringDeviceNestedFromJSON(json: any): ReadOnlyMonitoringDeviceNested {
    return ReadOnlyMonitoringDeviceNestedFromJSONTyped(json, false);
}

export function ReadOnlyMonitoringDeviceNestedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoringDeviceNested {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'clientId': json['client_id'],
        'client': !exists(json, 'client') ? undefined : ClientFromJSON(json['client']),
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'modules': !exists(json, 'modules') ? undefined : json['modules'],
        'monitoredObject': !exists(json, 'monitored_object') ? undefined : MonitoredObjectFromJSON(json['monitored_object']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'serialNumber': json['serial_number'],
        'externalVehicleId': !exists(json, 'external_vehicle_id') ? undefined : json['external_vehicle_id'],
        'isEva': !exists(json, 'is_eva') ? undefined : json['is_eva'],
        'monitoringDeviceType': json['monitoring_device_type'],
        'monitoringDeviceStatus': !exists(json, 'monitoring_device_status') ? undefined : json['monitoring_device_status'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
    };
}

export function ReadOnlyMonitoringDeviceNestedToJSON(value?: ReadOnlyMonitoringDeviceNested | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'client': ClientToJSON(value.client),
        'permissions': value.permissions,
        'monitored_object': MonitoredObjectToJSON(value.monitoredObject),
        'metadata': value.metadata,
        'serial_number': value.serialNumber,
        'external_vehicle_id': value.externalVehicleId,
        'is_eva': value.isEva,
        'monitoring_device_type': value.monitoringDeviceType,
        'monitoring_device_status': value.monitoringDeviceStatus,
        'external_system': value.externalSystem,
    };
}


